var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge"},[_c('v-btn',{attrs:{"title":_vm.title,"aria-label":_vm.title,"color":_vm.color,"icon":"","to":_vm.to}},[_c('v-icon',[_vm._v("mdi-bell-outline")])],1),_c('router-link',{staticClass:"badge-text",attrs:{"to":_vm.to}},[_c('span',{staticClass:"text--text bold-500"},[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }